// extracted by mini-css-extract-plugin
export default {"krybotDashboard":"KrybotDashboard_krybotDashboard__keqp5","krybotDashboardLoading":"KrybotDashboard_krybotDashboardLoading__FJsmK"};